// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Heous","warning":"styles_warning__NS+7R","description":"styles_description__SOSyn"};